import axios from 'axios';
import { apiBaseUrl } from '../config/constants';

const readUrl = (url = '') =>
  url.startsWith('http://') || url.startsWith('https://') ? url : `${apiBaseUrl}/${url}`

const getResult = async (url = '', headers = {}) => {
  const response = await axios.get(readUrl(url), {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...headers
    }
  });
  return response;
};

const get = (url = '', headers = {}) => axios.get(readUrl(url), {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers
  }
})

const post = (url = '', body = {}, headers = {}) => axios.post(readUrl(url), body, {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers
  }
})

const put = (url = '', body = {}, headers = {}) => axios.put(readUrl(url), body, {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers
  }
})

const del = (url = '', headers = {}) => axios.delete(readUrl(url), {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers
  }
})

export default {
  get,
  post,
  put,
  delete: del,
  getResult
}